// @ts-check
/**
 * @prettier
 */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _orderBy from 'lodash/orderBy';

import { getCardSettings } from 'cards/util/cardSettingsUtils';
import RadioButton from 'cards/components/common/ui/elements/RadioButton';
import getImageFromDraft from '../tools/getImageFromDraft';
import useImageOrientation from '../../../../../../helpers/hooks/useImageOrientation';

// @ts-ignore
import styles from './DraftSelectableItem.module.less';

const DraftSelectableItem = ({
  uuid,
  active,
  title,
  lastUpdate,
  customizations,
  onSelectDraft,
}) => {
  const containerClasses = cx(
    styles.container,
    { [styles.active]: active },
    { [styles.inactive]: !active }
  );
  const imageSrc = getImageFromDraft({ customizations });
  const { loading, orientation } = useImageOrientation(imageSrc);
  const imageContainerClasses = cx(styles.imageContainer, styles[orientation]);
  return (
    <section onClick={() => onSelectDraft(uuid)} className={containerClasses}>
      <div>
        <RadioButton active={active} onClick={() => onSelectDraft(uuid)} />
      </div>
      <div className={styles.detailContainer}>
        <h3 className={styles.header}>{title}</h3>
        <p className={styles.lastUpdated}>Last Updated: {lastUpdate}</p>
        <div className={styles.customizationsContainer}>
          {_orderBy(customizations, 'lead', 'desc')
            .filter(({ type }) => type !== 'ENVELOPE')
            .map(({ project_customization_uuid: customizationUuid, type, quantity }) => (
              <p className={styles.customization} key={customizationUuid}>
                <b>{getCardSettings(type).label}:</b>&nbsp;{quantity} Cards
              </p>
            ))}
        </div>
      </div>
      <div className={imageContainerClasses}>
        {!loading ? <img className={styles.mainImage} src={imageSrc} alt="Preview" /> : <div />}
      </div>
    </section>
  );
};

DraftSelectableItem.propTypes = {
  uuid: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  lastUpdate: PropTypes.string.isRequired,
  customizations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onSelectDraft: PropTypes.func,
};

export default DraftSelectableItem;



// WEBPACK FOOTER //
// ./src/cards/components/common/modals/ExistingDraftsForCardSuiteModal/components/DraftSelectableItem.jsx